import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import {
  GrantApprovalMutation,
  GrantApprovalMutationMutation,
  GrantApprovalMutationMutationVariables,
} from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'AcceptApprovalFormModal',
  props: {
    value: { type: Boolean },
    approvalId: null,
    resource: null,
    refetchQueries: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean
  approvalId: string
  resource: string
  refetchQueries: RefetchQueryDescription
}





const { mutate } = useMutation()
const { addSuccess } = useNotification()

watch(
  () => props.value,
  (newValue) => {
    if (newValue) {
      showModal.value = true
    }
  },
  {
    immediate: true,
  }
)

const showModal = ref(false)
const isSubmitting = ref(false)

const confirm = async () => {
  if (!props.approvalId) return
  isSubmitting.value = true

  const result = await mutate<
    GrantApprovalMutationMutation,
    GrantApprovalMutationMutationVariables
  >({
    mutation: GrantApprovalMutation,
    variables: {
      approvalId: props.approvalId,
    },
    done: () => {
      isSubmitting.value = false
    },
    refetchQueries: props.refetchQueries,
  })

  if (result?.data?.grantApproval && !result?.data?.grantApproval.error) {
    addSuccess(`${props.resource} approved successfully`)
    onCancel()
  }
}

const onCancel = () => {
  showModal.value = false
  emit("close")
}

return { __sfc: true,props, emit, mutate, addSuccess, showModal, isSubmitting, confirm, onCancel }
}

})